import axios from 'axios'
import { servantRanksRef, servantsRef, storageRef, rankRef } from '../../lib/firebaseService'
import {
  SERVANT_CHANGE, SERVANT_RANK_CHANGE, SERVANT_AVATAR_CHANGED, RANK_CHANGE, FETCH_PARAGON
} from './constants'

export const servantsChange = (servants) => ({type: SERVANT_CHANGE, payload: servants})

export const servantAvatarChanged = avatar => ({type: SERVANT_AVATAR_CHANGED, payload: avatar})

export const fetchAvatars = (servants) => {
  return (dispatch) => {
    Object.keys(servants).filter(s => servants[s].avatar).map(key => {
      return storageRef.child(`${key}/${servants[key].avatar}`).getDownloadURL().then(url => {
        dispatch(servantAvatarChanged({[key]: url}))
      }).catch(error => console.log('ERROR', error))
    })
  }
}

export const servantRanksChange = (servantRanks) => (
  { type: SERVANT_RANK_CHANGE, payload: servantRanks })

export const addServantListener = () => {
  return (dispatch, getState) => {
    servantsRef.once('value', (snapshot) => {
      const { servants } = getState()

      dispatch(servantsChange(snapshot.val()))
      // Want to fetch all avatars only when there are no avatars
      if (!servants.avatars) {
        dispatch(fetchAvatars(snapshot.val()))
      }
      if (!servants.paragons) {
        dispatch(fetchParagons(snapshot.val()))
      }
    })
  }
}

export const addServantRankListener = () => {
  return dispatch => {
    servantRanksRef.once('value', (snapshot) => {
      dispatch(servantRanksChange(snapshot.val()))
    })
  }
}

// RANKS
export const ranksChange = (ranks) => ({type: RANK_CHANGE, payload: ranks})

export const addRankListener = () => {
  return (dispatch) => {
    rankRef.orderByChild('level').once('value', (snapshot) => {
      let ranks = {}
      snapshot.forEach((data) => {
        ranks[data.key] = data.val()
      })
      dispatch(ranksChange(ranks))
    })
  }
}

// Paragons

export const setParagon= (servants) => ({type: FETCH_PARAGON, payload: servants})


export const fetchParagons = (servants) => {
  return (dispatch) => {
    Object.keys(servants).filter(s => servants[s].battleTag).map(key => {
     return axios.get(`http://diablo.azmklan.org/ajax/paragon.php?battleTag=${servants[key].battleTag}`).then(response => {
        if (response.status === 200 && (response.data.paragonLevel || response.data.paragonLevelHardcore)) {
          dispatch(setParagon({[response.data.battleTag]: response.data}))
        } else {
          dispatch(setParagon({[servants[key].battleTag]: {}}))
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/reducers/servants/actions.js